import React from 'react';

import * as S from './CreateTriggerDrawerLoaded.styles';

/**
 * Page 3 of Create trigger drawer
 * Add name and description for the trigger
 */

type DrawerPageSummaryProps = {
  triggerName: string;
  triggerDescription: string;
  defaultTriggerDescription: string;
  setTriggerName: (val: string) => void;
  setTriggerDescription: (val: string) => void;
};

export const DrawerPageSummary = ({
  triggerName,
  triggerDescription,
  defaultTriggerDescription,
  setTriggerName,
  setTriggerDescription,
}: DrawerPageSummaryProps) => {
  return (
    <>
      <S.PageLabelRow>Step 3 of 3 - Summary</S.PageLabelRow>
      {defaultTriggerDescription}
      {/*TODO: Render default trigger description with styling*/}
      <S.LabelRow>
        <S.Label>Automation name</S.Label>
      </S.LabelRow>
      <S.StyledTextField
        placeholder="Name your automation"
        value={triggerName ?? ''}
        onChange={value => setTriggerName(value)}
        autoFocus={true}
      />
      <S.LabelRow>
        <S.Label>Description</S.Label>
      </S.LabelRow>
      <S.StyledTextArea
        value={triggerDescription ?? ''}
        placeholder={defaultTriggerDescription}
        handleChange={(value: string) => setTriggerDescription(value)}
      />
    </>
  );
};
